import React, { useEffect, useState } from "react";
import { Layout, Menu, Avatar, Dropdown, Typography, Button, Grid } from "antd";
import {
  HomeOutlined,
  FilePdfOutlined,
  QrcodeOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "./Dashboard.css";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const Dashboard = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const screens = useBreakpoint();
  const [collapsed, setCollapsed] = useState(!screens.md);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    setCollapsed(!screens.md);
  }, [screens.md]);

  useEffect(() => {
    if (!screens.md) {
      setCollapsed(true);
    }
  }, [window.location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        // breakpoint="md"
        // collapsible
        collapsed={collapsed}
        collapsedWidth="0"
        onCollapse={setCollapsed}
        width={screens.md ? 200 : "100%"}
        theme="light"
        style={{
          borderRight: "1px solid #f0f0f0",
          ...(!screens.md
            ? {
                position: "fixed", // Make Sider fixed
                height: "100vh",

                left: 0,
                top: 0,
                bottom: 0,
                zIndex: 1000,
              }
            : {}),
        }}
      >
        <div className="logo">
          <img
            src={require("../../assets/logo.png")}
            alt="logo"
            style={{ cursor: "pointer", maxWidth: "100%" }}
            onClick={() => {
              navigate("/dashboard/home");
            }}
          />
          {!screens.md && (
            <CloseOutlined
              style={{ fontSize: 20 }}
              onClick={() => {
                setCollapsed(true);
              }}
            />
          )}
        </div>
        <Menu mode="inline" defaultSelectedKeys={["tools"]}>
          <Menu.Item
            key="tools"
            icon={<HomeOutlined />}
            onClick={() => {
              navigate("/dashboard/home");
            }}
          >
            Tools
          </Menu.Item>
        </Menu>
        <div style={{ padding: "12px 16px", fontSize: "12px", color: "#888" }}>
          TOOLS
        </div>
        <Menu theme="light" mode="inline">
          <Menu.Item
            key="pdf"
            icon={<FilePdfOutlined />}
            onClick={() => {
              navigate("/dashboard/pdf-list");
            }}
          >
            PDF Converted
          </Menu.Item>
          <Menu.Item
            key="qr"
            icon={<QrcodeOutlined />}
            onClick={() => {
              navigate("/dashboard/qr-list");
            }}
          >
            My QR Codes
          </Menu.Item>
        </Menu>
      </Sider>

      <Layout>
        <Header
          className="header-bar"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 16px",
            background: "#fff",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          {!screens.md ? (
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontSize: "20px" }}
            />
          ) : (
            <div />
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <div style={{ textAlign: "right" }}>
              <Typography.Text strong>{user.name}</Typography.Text>
              <br />
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {user.username}
              </Typography.Text>
            </div>
            <Dropdown
              overlay={userMenu}
              placement="bottomRight"
              trigger={["hover"]}
            >
              <Avatar
                size={"large"}
                icon={<UserOutlined />}
                style={{ cursor: "pointer" }}
              />
            </Dropdown>
          </div>
        </Header>

        <Content
          style={{
            width: "100%",
            padding: "24px 16px",
            margin: "0 auto",
            background: "#f5f5f9",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
